
import React, { Component } from 'react'
import axios from 'axios'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css'
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));

class AddPaymentPage extends Component {
    constructor(props) {
        super(props)
      
        this.state = {
            cardname: '',
            cardno: '',
            card_type: '',
            cvvs: '',
            month: '',
            year: '',
            userid : loggedInUserID


        }
    }

    changeHandler = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submitHandler = e => {
        e.preventDefault()
        console.log(this.state)
        axios
            .post('https://shoppee-clone.herokuapp.com/order', this.state,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(response => {
                console.log(response)


                window.location.replace("/order");

            })

    }

    backtoorder(event) {
        event.preventDefault();
        window.location.replace("/order");
    }
    render() {
        const { cardname, cardno, card_type, cvvs, month, year } = this.state
        return (



            <aside>
                <form onSubmit={this.submitHandler} autocomplete="off">
                    <div className="rounded d-flex justify-content-center" style={{ marginTop: '100px' }}>
                        <div className="col-md-4 col-sm-12 shadow-lg p-5 bg-light">
                            <div className="p-4">
                                
                            <i class="bi bi-credit-card"></i>  Name on Card
                                <div className="input-group mb-3 ">
                                    <input type="text" className="form-control" name="cardname" required="required"  value={cardname}  onChange={this.changeHandler} ></input>
                                </div>
                                
                                <i class="bi bi-credit-card-2-front"></i>  Credit Card Number
                                <div className="input-group mb-3 ">
                                    <input type="text" className="form-control"name="cardno"   required="required"   value={cardno} onChange={this.changeHandler} />
                                </div>
                                <div className="col-4">
                                    <input type="text" className="form-control" name="cvvs" placeholder="CVV"  required="required" value={cvvs} onChange={this.changeHandler} />
                                </div>
                                Card Expiration:<br />
                                <fieldset>
                                    <select className="mb-2 form-select">
                                        <option name="month" value={month}  onChange={this.changeHandler}>Month</option>
                                        <option value="01" >01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>

                                    </select>
                                </fieldset>
                                <fieldset>
                                    <select  className="mb-2 form-select">
                                        <option name="year" value={year}  onChange={this.changeHandler}>Year</option>
                                        <option value="22">22</option>
                                        <option value="23">23</option>
                                        <option value="24">24</option>
                                        <option value="25">25</option>
                                        <option value="26">26</option>
                                        <option value="27">27</option>
                                        <option value="28"> 28</option>
                                        <option value="29"> 29</option>
                                        <option value="30">30</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <div className="form-group">
                                        <div className="col-6">
                                            <select id="card-type" className="mb-2 form-select" aria-label="Default select example">
                                                <option name="card_type" value={card_type} onChange={this.changeHandler}>Card type</option>   
                                                <option value="MasterCard">MasterCard</option>
                                                <option value="Visa">Visa</option>
                                                <option value="American Express">American Express</option>
                                            </select><input type="submit" className="btn btn-primary text-center mt-2" defaultValue="Submit " />
                                        </div>
                                    </div></fieldset></div></div></div></form></aside>

        )
    }
}

export default AddPaymentPage



